import { motion } from "framer-motion";

// Reusable scroll-reveal wrapper: fades up + slight scale
export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y, scale: 0.995 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </M>
  );
};

// Masked line reveal (for hero headings). Wrap each line.
export const lineParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};
export const lineChild = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1.05, ease: [0.22, 1, 0.36, 1] } },
};
